export default "__VITE_ASSET__7q0e4H$e__"